import React, { useEffect, useState } from 'react';
import { Topbar, CalendarModal } from '@components';
import { useNavigate } from 'react-router-dom';
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import { CalendarFilled } from '@assets';
import { api } from '@api';
import { Space, Spin, message } from 'antd';
import {
  BoldText,
  Button,
  Divider,
  EmptyBox,
  EmptyText,
  Item,
  LightText,
  Loader,
  RootContainer,
  StatusBox,
  TopBox,
  Box,
} from './PromoCodeHistory.style';
import {
  ContainerOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { getFormattedNumber } from '@utils';

const apiDateFormat = 'YYYY-MM-DD';

const PromoCodeHistory = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    getCommissionHistory(date);

    // eslint-disable-next-line
  }, [date]);

  const getCommissionHistory = (date) => {
    if (!loading) {
      setLoading(true);
      api
        .getCommissionHistory({ date })
        .then(({ transactions, rewarded_info }) => {
          setLoading(false);
          setData(transactions);
          setAmount(rewarded_info.rewarded_amount);
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  }

  const onOk = (newdate) => {
    newdate = newdate.format(apiDateFormat);
    if (newdate !== date) {
      setDate(newdate);
      setData([]);
    }
    handleClose();
  }

  const onReset = () => {
    if (date) {
      setDate('');
      setData([]);
    }
  }

  const handleClose = () => {
    setOpen(false);
  }

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`);
  };

  const goToTerms = () => {
    navigate(`/${PRIVATE_ROUTE.PROMO_TERMS}`);
  }

  const renderTop = () => (
    <TopBox>
      <LightText> {t("profile.amount")} </LightText>
      <BoldText> {getFormattedNumber(amount)} </BoldText>
    </TopBox>
  );

  const EmptyCard = () => (
    <EmptyBox>
      <ContainerOutlined />
      <EmptyText>
        {t("common.noRecord")}
      </EmptyText>
    </EmptyBox>
  );

  return (
    <>
      <Topbar
        title={t("profile.promoCodeHistory")}
        rightIcon={
          <CalendarFilled onClick={() => setOpen(true)} />
        }
        goBack={goBack}
      />
      {loading
        ? <Loader>
          <Spin />
        </Loader>
        : data.length === 0
          ? <EmptyCard />
          : (
            <RootContainer>
              {renderTop()}
              {data.map((item, key) => (
                <Item key={key}>
                  <LightText>
                    {item.date}
                  </LightText>
                  <Box>
                    <Space>
                      <LightText>
                        {`${t("profile.register")} x ${item.register_count}`}
                      </LightText>
                      <BoldText>
                        {`${getFormattedNumber(item.register_commission_amt)}`}
                      </BoldText>
                    </Space>
                    <Space>
                      <LightText>
                        {`${t("profile.topup")} x ${item.topup_count}`}
                      </LightText>
                      <BoldText>
                        {`${getFormattedNumber(item.topup_commission_amt)}`}
                      </BoldText>
                    </Space>
                    <Divider />
                    <Space>
                      <StatusBox
                        isPending={!item.rewarded && "true"}
                      >
                        {item.rewarded ? t("profile.received") : t("profile.pending")}
                      </StatusBox>
                      <BoldText>
                        {`${getFormattedNumber((item.register_count * item.register_commission_amt) + (item.topup_count * item.topup_commission_amt))}`}
                      </BoldText>
                    </Space>
                  </Box>

                </Item>
              ))}
            </RootContainer>
          )
      }
      <Button
        size='large'
        type='default'
        onClick={goToTerms}
      >
        {t("common.termsAndConditions")}
      </Button>
      <CalendarModal
        open={open}
        date={date}
        onOk={onOk}
        onReset={onReset}
        handleClose={handleClose}
      />
    </>
  );
}

export default PromoCodeHistory;